<div
  class="bella-balea-logo"
  (click)="backToHome()"
>
  <img src="/assets/images/bblogo.png" width="130" alt="">
</div>
